"use strict";

// Обрабатываем клики по контейнерам (а также - мимо контейнеров)
// вероятно, имя файла нужно изменить, но пока неясно, как.
// jquery.fotobook.element.editors.js слишком перегружен, поэтому код вынесен сюда
//
// Так как нам нужно, чтобы клик мимо контейнера отрабатывал до других обработчиков,
// используем event capturing, который срабатывает ДО bubbling-событий, обрабатываемых jQuery
(function(){
    function processClick(e){

        if (!Fotobook.onlineEditorActive()) {
            return;
        }

        //обрабатываем событие по нажатию на фотоконтейнер (.foto-container onClick event handler)
        var event = e instanceof jQuery.Event ? e : $.event.fix(e),
            $target = $(event.target), $element, $book, widget, $toolbar,
            qtipWidget = $target.closest(".qtip").data("qtip"),
            select_click = event.ctrlKey && event.type == "click";

        if ($target.is('img') && $target.closest(".tb-element").length) {
            $target.closest(".tb-element").trigger("click");
            return;
        }

        var ignoreClickSelectors = [
            '.colorpicker',
            '#redactor_modal',
            '#fotobook-uploader-input',
            '.ui-dialog:not(.spine-editor)',
            '.controls-button',
            '.jspVerticalBar',
            '.jspHorizontalBar',
            '.low-quality-mark',
            '.ui-widget-overlay',
            '.do-not-open-editor',
            '.ui-datepicker',
            '.ui-widget.month-picker',
        ];

        if ($target.closest(ignoreClickSelectors.join()).length) {
            return;
        }

        if (event.type == "dragstart" && $target.closest(".page-container,.album-fotos").length) {
            $(".tb-popup.active").removeClass("active");
            return;
        }


        $(".tb-popup.active").not($target.closest(".tb-popup")).removeClass("active");

        if (qtipWidget && qtipWidget.target.hasClass("editorToolbar")){
            $toolbar = qtipWidget.target;
        } else {
            $toolbar = $target.closest(".editorToolbar");
        }
        if (!$toolbar.length) {
            var dropdown = $target.closest(".redactor-dropdown");
            if (dropdown.length){
                $toolbar = dropdown.data("fotobook-containerEditor-toolbar");
            }
        }
        if (!$toolbar.length && $target.closest(".spine-editor").length) {
            return;
        }

        $book = $target.parents("#book");
        if (!$book.length) {
            $element = $();
        } else if (select_click) {
            // только корневые контейнеры
            $element = $target.closest(".page-container.top-level:not(.locked)");
        } else {
            $element = $target.closest(".page-container");
            if ($element.length) {
                // Группы внутри групп не редактируем
                if ($element.hasClass("group-container") && !$element.hasClass("top-level")) {
                    $element = $element.closest(".page-container.top-level");
                }
            } else if (Fotobook.store.getters['OnlineEditor/editMode'].code !== Fotobook.EditModeCode.INSTANT) {
                var $page = $target.closest(".book-page");
                if (!$page.hasClass("flyleaf-page") && (Fotobook.book.cover.foto_clipart || !$page.hasClass("cover"))) {
                    $element = $target.closest(".bg-content");
                }
            }
        }
        if (select_click && $element.length && $element.hasClass("spine")){
            $element = $();
        }

        // Здесь ловятся клики на тулбар ($element - пустой)
        if ($toolbar.length) {
            $(".editorToolbar").not($toolbar).each(function(){
                $(this).data("fotobook-containerEditor-widget").destroy();
            });
            widget = $toolbar.data("fotobook-containerEditor-widget");
            if (!$target.hasClass("disabled") && !$target.hasClass("tb-popup-window") && ($target.hasClass("tb-button") || $target.parent().hasClass("tb-button") || $target.hasClass("tb-click"))) {
                event.data = {"widget": widget};
                var tgt = ($target.hasClass("tb-button") || $target.hasClass("tb-click")) ? event.target : event.target.parentElement; // Chrome alternative target fix
                widget.processButton.call(tgt, event);
            }
            if ($target.hasClass("open-list")) {
                widget.updateToolbarPosition_lists();
            }
        } else if (select_click && Fotobook.store.getters['OnlineEditor/editMode'].code !== Fotobook.EditModeCode.INSTANT) {
            if ($element.length && !$element.data("fotobook-containerEditor")) {
                $element.toggleClass("selected");
            }
            $(".editorToolbar").each(function(){
                var widget = $(this).data("fotobook-containerEditor-widget");
                if (!widget._isSelection()) {
                    widget.element.closest(".top-level:not(.locked)").toggleClass("selected");
                    widget.destroy();
                }
            });

            widget = Fotobook.book.getSelectionWidget();
            if ($(".page-container.selected").length) {
                if (widget) {
                    widget.updateToolbarPosition();
                    widget._checkButtons();
                } else {
                    $(Fotobook.book.book).find(".pages-wrapper").containerEditor();
                }
            } else if (widget) {
                widget.destroy();
            }
        } else {
            $(".editorToolbar").each(function(){
                var widget = $(this).data("fotobook-containerEditor-widget");
                if (widget && (!$element.length || $element[0] != widget.element[0])) {
                    widget.destroy();
                }
            });
            // Если сюда дошли, и найден элемент - надо запустить редактор
            if (event.type === "click" && $element.length &&
                (!$element.hasClass("locked") || $element.hasClass("foto-container")) &&
                !$element.data("fotobook-containerEditor")
            ) {
                // не открывать меню для следующих селекторов
                var excludeSelectors = ['.artefact-container', '.foto-container', '.bg', '.calendar-container'];
                if (Fotobook.store.getters['OnlineEditor/editMode'].code === Fotobook.EditModeCode.INSTANT && $element.is(excludeSelectors.join(','))) {
                    return;
                }
                // нет модуля - отключить меню
                if ($element.hasClass("calendar-container") && !Fotobook.store.getters['services/calendarSubscribed']) {
                    return false;
                }
                if ($element.hasClass('bg-content')){
                    if ($element.hasAttr('tmWarning')){
                        clearTimeout($element.attr('tmWarning'));
                        $element.removeAttr('tmWarning');
                    } else {
                        $element.attr('tmWarning', setTimeout(function(){
                            Fotobook.notification.showWarning(t('photobook-js-bgEdit-warning'));
                            $element.removeAttr('tmWarning');
                        }, 500));
                    }
                    return;
                }
                $element.containerEditor();
            }
        }
    }

    // используем capturing
    document.addEventListener("click", processClick, true);

    $(document).on("dragstart", processClick);

})();
